import FILECHECK_PREFIX from "constants/FILECHECK_PREFIX"
import guess_filename from "js/files/naming/guess_filename"
import { startswith } from "workflow/utils/strings"

export default name => startswith(guess_filename(name), FILECHECK_PREFIX)
